import { useNavigate } from '@tanstack/react-router';
import { useGetUserQuery } from 'api';
import { useEffect } from 'react';
import type { ResourceType } from 'types/models';

export const useGetExpectedRoleIdFromParams = (resourceType: ResourceType, resourceId: number) => {
  const getUserQuery = useGetUserQuery();
  const user = getUserQuery.data?.user;
  const navigate = useNavigate();

  const expectedRoleId = resourceId
    ? user?.roles.find(
        (role) => role.resource_type === resourceType && role.resource_id === resourceId
      )?.id
    : null;

  useEffect(() => {
    if (getUserQuery.isPending) return;
    if (!expectedRoleId) navigate({ to: '/' });
  }, [expectedRoleId, getUserQuery.isPending, navigate]);

  return expectedRoleId;
};
